import Vue from 'vue'
import Vuex from 'vuex'
import { asyncRoutes, resetRouter, qcAsyncRoutes } from '@/router/router'
import { getUserInfo } from '@/api/user'
import { getVersionInfo } from '@/api/version'
import { hasPermission, industryToTreeData } from '@/components/public'
Vue.use(Vuex)

// 按具体的业务逻辑归类状态，避免一个文件管理多个状态
const store = new Vuex.Store({
  // 存放全局状态
  state: {
    routes: [],
    // 权限列表清单
    scopes: [],
    // 克隆计划id数组
    copyPlanIdList: [],
    // 创意分类全局数据
    industryList: [],
    currentMenuL: '',
    currentMenuT: '',
    topMenuList: [],
    // 用户信息
    userInfo: {
      userEmail: '',
      userName: '',
      userRole: '',
      id: '',
      enterpriseId: ''
    },
    // 版本信息
    versionInfo: {
      versionNumber: '',
      versionContent: ''
    },
    // 路由切换loading
    loadingShow: false,
    // menuList: [],
    leftMenuList: [],
    // 公共筛选条件（产品、项目）
    screeningProductList: [],
    screeningProjectList: [],
    screeningProduct: '',
    screeningProject: ''
  },
  // 修改state下的全局状态
  mutations: {
    changeScreeningItem(state, data) {
      state.screeningProduct = data[0].product
      state.screeningProject = data[0].project
      state.screeningProductList = data[1]
      state.screeningProjectList = data[2]
      console.log('changeScreeningItem screeningProject', state.screeningProject)
    },
    // 存储所有权限清单list
    setScopes(state, data) {
      console.log('mutations setScopes')
      state.scopes = data
    },
    updataCopyPlanIdList(state, data) {
      /**
      *copyPlanIdList是state内需要被修改的数据
      *data是传来的数据
      */
      state.copyPlanIdList = data
    },
    // 获取当前路由名称
    getRouteName (state, path) {
      // currentMenuL 二级导航 currentMenuT 一级导航
      const pathArr = path.split('/')
      // let length = pathArr.length
      if (path.startsWith('/qianchuan')) {
        state.currentMenuT = `/${pathArr[2]}`
        state.currentMenuL = `${pathArr[3]}`
      } else {
        state.currentMenuL = `${pathArr[2]}`
        state.currentMenuT = `/${pathArr[1]}`
      }

      // state.currentMenuL = `/${path.split('/')[1]}` + `/${path.split('/')[2]}`
      // console.log(path)
      console.log('state.currentMenuL ' + state.currentMenuL, 'state.currentMenuT ' + state.currentMenuT)
    },
    // 获取左侧路由菜单项
    setMenuList (state, narr) {
      state.leftMenuList = narr
    },
    initUserInfo (state, res) {
      // 初始化防止VUE无法监听到对象属性发生变化
      state.userInfo = {}
      state.userInfo.userEmail = res.result.userName
      state.userInfo.userName = res.result.employeeName
      state.userInfo.userRole = res.result.roleCode
      state.userInfo.userRoleName = res.result.roleName
      state.userInfo.id = res.result.id
      state.userInfo.enterpriseId = res.result.enterpriseId
      state.userInfo.enterpriseName = res.result.enterpriseName
    },
    versionInfo (state, res) {
      // console.log('versionInfo', res)
      if (res.result) {
        state.versionInfo = {}
        state.versionInfo.versionNumber = res.result.versionNumber
        state.versionInfo.versionContent = res.result.versionExplain.split(/\n/g)
      }
    },
    clearUserInfo (state) {
      console.log('clearUserInfo')
      state.userInfo = {}
      state.scopes = []
      state.routes = []
      state.topMenuList = []
      state.leftMenuList = []
      resetRouter()
    },
    initIndustryList (state, industryList) {
      state.industryList = industryList
    },
    initTopMenuList (state, menuList) {
      state.topMenuList = menuList
    },
    initasyncRoutes(state, lasyncRoutes) {
      state.routes = (lasyncRoutes || [])
    }
  },
  // 处理异步及耗时业务逻辑
  actions: {
    // 调用方式 this.$store.dispatch('getIndustryList')
    getIndustryList (context) {
      const provinceList1 = require('@/config/industry.json')
      const arr = JSON.parse(JSON.stringify(provinceList1))

      // let map = {} // 构建map
      // arr.forEach(i => {
      //   map[i.industryId] = i // 构建以area_id为键 当前数据为值
      // })

      // let treeData = []
      // arr.forEach(child => {
      //   const mapItem = map[child.fatherId] // 判断当前数据的parent_id是否存在map中
      //   if (mapItem) { // 存在则表示当前数据不是最顶层数据
      //     // 注意: 这里的map中的数据是引用了arr的它的指向还是arr，当mapItem改变时arr也会改变,踩坑点
      //     (mapItem.children || (mapItem.children = [])).push(child) // 这里判断mapItem中是否存在children, 存在则插入当前数据, 不存在则赋值children为[]然后再插入当前数据
      //   } else { // 不存在则是组顶层数据
      //     treeData.push(child)
      //   }
      // })
      context.commit('initIndustryList', industryToTreeData(arr))
      // console.log(treeData);
    },

    async getTopMenuList(context, type) {
      let menuList = []
      let asyncRoutesendList = []
      let routes = []
      if (type === 1) {
        routes = qcAsyncRoutes
      } else {
        routes = asyncRoutes
      }
      routes.forEach((item, index) => {
        if (hasPermission(item.meta.permission) || !item.meta.permission) {
          let obj = {}
          obj['id'] = index
          obj['name'] = item.meta.name
          obj['activeName'] = item.meta.activeName
          obj['title'] = item.meta.title
          // obj['path'] = item.path
          if (item.children) {
            // 删除用户没有的左侧菜单权限的注册
            for (let i = item.children.length - 1; i >= 0; i--) {
              const citem = item.children[i]
              if (citem.meta.permission && !hasPermission(citem.meta.permission)) {
                item.children.splice(i, 1)
                console.log('del ' + citem.meta.permission)
              }
              if (citem.children) {
                for (let j = citem.children.length - 1; j >= 0; j--) {
                  const kitem = citem.children[j]
                  if (kitem.meta.permission && !hasPermission(kitem.meta.permission)) {
                    if (citem.children) {
                      citem.children.splice(j, 1)
                    }
                    if (citem.subMenu) {
                      citem.subMenu.splice(j, 1)
                    }
                    console.log('del ' + kitem.meta.permission)
                  }
                }
              }
            }
            // 处理路由因权限原因默认不是第一个路由时切换到第一个路由
            if (item.children.length > 0) {
              const firstChild = item.children[0]
              if (firstChild.meta.subMenuShow || (firstChild.subMenu && firstChild.subMenu.length)) {
                obj['name'] = firstChild.subMenu[0].name
                item.meta.name = firstChild.subMenu[0].name
                console.log('firstChild.subMenu.name', obj['name'])
              } else if (item.meta.name !== firstChild.name) {
                item.meta.name = firstChild.name
                // item.path = firstChild.path
                obj['name'] = firstChild.name
                // obj['path'] = firstChild.path
                console.log('firstChild.name', firstChild.name)
              }
            }
          }
          menuList.push(obj)
          asyncRoutesendList.push(item)
        }
      })
      context.commit('initTopMenuList', menuList)
      context.commit('initasyncRoutes', asyncRoutesendList)
      console.log('getTopMenuList', menuList)
      console.log('asyncRoutesendList', asyncRoutesendList)
      return asyncRoutesendList
    },
    // 获取侧边导航
    getMenuList (context, type) {
      let routes = asyncRoutes
      if (type === 1) {
        routes = qcAsyncRoutes
      }
      // 找出符合条件的左侧菜单
      var resultItem = routes.find(item => {
        return item.meta.activeName === context.state.currentMenuT
      })
      // console.log('getMenuList', resultItem)
      if (resultItem && resultItem.children) {
        const narr = resultItem.children.filter(mitem => {
          // 没有权限清单放行, 有权限清单则验证权限
          return !mitem.meta.permission || hasPermission(mitem.meta.permission)
        })
        console.log('getMenuList', narr)
        context.commit('setMenuList', narr || [])
      } else {
        // 置空 防止异常情况出现
        context.commit('setMenuList', [])
      }
    },
    // 调用方式 this.$store.dispatch('getUserInfo')
    async getUserInfo (context) {
      const res = await getUserInfo()
      context.commit('initUserInfo', res)
    },
    async getVersionInfo (context) {
      const res = await getVersionInfo()
      context.commit('versionInfo', res)
    }
  },
  getters: {
    industryList: state => state.industryList,
    userRole: state => state.userInfo.userRole,
    versionNumber: state => state.versionInfo.versionNumber,
    scopes: state => state.scopes,
    routes: state => state.routes || [],
    topMenuList: state => state.topMenuList || [],
    screeningProduct: state => state.screeningProduct || parseInt(localStorage.screeningProduct),
    screeningProject: state => state.screeningProject || parseInt(localStorage.screeningProject)
  }
})
// 导出
export default store



// WEBPACK FOOTER //
// ./src/store/store.js